import { createFileRoute } from '@tanstack/react-router'
import { AccountingOrdersPage } from '@/features/accounting-orders'

export const Route = createFileRoute('/_authenticated/accounting-orders/')({
  component: AccountingOrdersPage,
})
